"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _color = _interopRequireDefault(require("color"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(props) {
  var isLight = true;
  if (props.secondaryColor.length > 0) {
    isLight = (0, _color["default"])(props.secondaryColor).luminosity() > 0.5;
  }
  var handleDeleteContainer = function handleDeleteContainer(containerId) {
    var indexOfContainer = props.containers.findIndex(function (container) {
      return container.id === containerId;
    });
    props.containers.removeField(indexOfContainer);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper,
    style: {
      borderColor: props.primaryColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header,
    onClick: function onClick() {
      return props.handleCollapse(props.id);
    },
    style: {
      backgroundColor: props.secondaryColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerIcon,
    style: {
      color: props.primaryColor
    }
  }, props.collapsed.includes(props.id) ? /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
    spaceRight: true
  }) : /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
    spaceRight: true
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerContent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerTitle,
    style: {
      color: props.primaryColor
    }
  }, props.title.value), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerDesc,
    style: isLight ? {
      color: '#666'
    } : {
      color: '#fff'
    }
  }, props.description.value), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].containerMenu
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: props.title.value,
    size: "large",
    trigger: /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: '3px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_pencil["default"], null),
      className: "btn btn-success btn-xs"
    })),
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        label: "Title",
        field: props.title,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        label: "Description",
        field: props.description,
        required: true
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: closeModal
      }, "Ok"));
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
    className: "btn btn-danger btn-xs ".concat(_style["default"].deleteButton),
    isConfirm: true,
    confirmationMessage: "Are you sure you want to delete this Report Container: ".concat(props.title.value || "Unlabeled Container", "?"),
    onClick: function onClick() {
      return handleDeleteContainer(props.id);
    }
  })))), !props.collapsed.includes(props.id) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, props.children));
};